import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

function QuoteSection() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // EmailJS parameters
    const templateParams = {
      from_name: `${formData.firstName} ${formData.lastName}`,
      from_email: formData.email,
      from_phone: formData.phone,
      company: formData.company,
      service: formData.service,
      message: formData.message,
      to_name: 'Stargate Shipping Team'
    };

    // Send email using EmailJS
    emailjs.send(
      'service_uf65iz9',     // Replace with your EmailJS Service ID
      'template_rw6pmrq',    // Replace with your EmailJS Template ID
      templateParams,
      'fC6zTq2LdYydpiesC'      // Replace with your EmailJS Public Key
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      alert('Thank you for your request! We will get back to you shortly.');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        message: ''
      });
    })
    .catch((error) => {
      console.log('FAILED...', error);
      // error message
      if (error.text) {
        alert(`Oops! Something went wrong. Please try again later.`);
      }
    });
  };

  return (
    <section id="quotesection" className="section-padding bg-gradient-to-r from-red to-orange">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <div className="bg-ash-dark backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-red/30">
            <div className="text-center mb-10">
              <h2 className="heading-secondary mb-6 text-white">
                Get Your <span className="text-red">Quote</span> Today
              </h2>
              <p className="text-xl text-gray-light max-w-2xl mx-auto">
                Ready to streamline your international logistics? 
                Fill out the form below and our team will provide a customized solution.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="firstName" className="block text-white font-medium mb-2">First Name</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-ash border border-red/20 rounded-lg text-white placeholder-gray-light focus:outline-none focus:ring-2 focus:ring-red focus:border-red transition-all duration-300"
                    placeholder=""
                  />
                </div>
                
                <div>
                  <label htmlFor="lastName" className="block text-white font-medium mb-2">Last Name</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-ash border border-red/20 rounded-lg text-white placeholder-gray-light focus:outline-none focus:ring-2 focus:ring-red focus:border-red transition-all duration-300"
                    placeholder=""
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-white font-medium mb-2">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-ash border border-red/20 rounded-lg text-white placeholder-gray-light focus:outline-none focus:ring-2 focus:ring-red focus:border-red transition-all duration-300"
                    placeholder=""
                  />
                </div>
                
                <div>
                  <label htmlFor="phone" className="block text-white font-medium mb-2">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-ash border border-red/20 rounded-lg text-white placeholder-gray-light focus:outline-none focus:ring-2 focus:ring-red focus:border-red transition-all duration-300"
                    placeholder=""
                  />
                </div>
                
                <div>
                  <label htmlFor="company" className="block text-white font-medium mb-2">Company</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-ash border border-red/20 rounded-lg text-white placeholder-gray-light focus:outline-none focus:ring-2 focus:ring-red focus:border-red transition-all duration-300"
                    placeholder=""
                  />
                </div>
                
                <div>
                  <label htmlFor="service" className="block text-white font-medium mb-2">Service Interested In</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-ash border border-red/20 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-red focus:border-red transition-all duration-300"
                  >
                    <option value="" className="bg-ash-dark">Select a service</option>
                    <option value="sea-freight" className="bg-ash-dark">Sea Freight</option>
                    <option value="air-freight" className="bg-ash-dark">Air Freight</option>
                    <option value="roro" className="bg-ash-dark">RoRo (Roll-on/Roll-off) Services</option>
                    <option value="warehousing" className="bg-ash-dark">Warehousing & Distribution</option>
                    <option value="customs" className="bg-ash-dark">Customs Brokerage</option>
                    <option value="project-cargo" className="bg-ash-dark">Project Cargo Handling</option>
                    <option value="supply-chain" className="bg-ash-dark">Supply Chain Management</option>
                  </select>
                </div>
              </div>
              
              <div>
                <label htmlFor="message" className="block text-white font-medium mb-2">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-4 py-3 bg-ash border border-red/20 rounded-lg text-white placeholder-gray-light focus:outline-none focus:ring-2 focus:ring-red focus:border-red transition-all duration-300"
                  placeholder="Tell us about your shipping needs..."
                ></textarea>
              </div>
              
              <div className="text-center pt-6">
                <button type="submit" className="bg-gradient-to-r from-red to-orange hover:from-orange hover:to-red text-white font-semibold px-10 py-4 rounded-lg text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-red/30">
                  Request Quote
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default QuoteSection;